/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */
import * as ModelsFromStore  from '@apps-store/models';
import * as EnumsFromStore from '@apps-store/enums';
import { Dispatch } from 'redux';
import { Auth } from 'aws-amplify';

import * as Utils from '@root-utils/index';

/**
 * @function LoginActionSuccess  - 
 * @return { object } payload
 * @returns { string }  type
 * @param { any } 
 */
export function LoginActionSuccess(data:any): ModelsFromStore.LoginActionSuccess {

    return {
        
        payload:{

            data,
            loading: false,
            

        },

        type :EnumsFromStore.LoginTypes.LOGIN_SUCCESS

    }
}

/**
 * @function LoginActionFail  - 
 * @return { object }   payload
 * @returns { string }  type
 * @param { any } 
 */
export function LoginActionFail(errors: any): ModelsFromStore.LoginActionFail {

    return {
        payload:{

            error: errors  ,
            loading: false,
            
        },

        type :EnumsFromStore.LoginTypes.LOGIN_FAIL

    }
}
/**
 * @function LoginActionInProgress  - 
 * @return { object }   payload
 * @returns { string }  type
 * @param {  } 
 */
export function LoginActionInProgress(): ModelsFromStore.LoginActionInProgress{

    return {
        payload:{

         
            loading: true,
            
        },

        type :EnumsFromStore.LoginTypes.LOGIN_INPROGRESS

    }
}


// CREATOR

/**
 * @function LoginActionCreator
 * @param { any } user
 * @return {Promise<any>}  Promise
 */
export function LoginActionCreator(user: any):(dispatch: Dispatch<any>, {}) => Promise<any>{
 
    return  async (dispatch: Dispatch<any>) => {

        dispatch(LoginActionInProgress());

      
        await   Auth.signIn(user.identifiant, user.password)
                .then((data: any) => {
                  
                    if(data.signInUserSession){
                        Utils.localStorageSetItem(data.signInUserSession.idToken.jwtToken);
                        dispatch(LoginActionSuccess("a user has been found"));   
                    }else{ dispatch(LoginActionFail("server error has occurred with HTTP status ("+data.status+ ")" ))}
                })
                .catch( (error : any) => dispatch(LoginActionFail(error))) 
    }
    
}



// WEBPACK FOOTER //
// ./src/apps/store/action-creator/login/index.ts